// extract.bookmarklet.js — "Extract" bookmarklet payload.
//
// Extracted verbatim from settings-panel.js (Stage A of the monolith split).
// Pure: takes a derived palette `p` (see _deriveBookmarkletPalette in
// settings-panel.js) and returns the bookmarklet source string. The template
// content is intentionally flush-left — do not re-indent the body.
//
// Output layouts (chosen in the Learn Page panel, `pageExtractorLayout`):
// - 'row' (default): one tab-separated line — pastes across Excel columns.
//   Cells are the raw values (no markdown decoration); 'blank' fields become
//   empty cells, 'url' fields the bare page URL.
// - 'doc': the original vertical markdown (email / Word / notes).
// The toast offers a one-click re-copy in the other layout.
//
// The toast runs on foreign pages where base.css can't reach, so it inlines
// the no-visible-scrollbars rules scoped to #pex-toast (keep in sync with
// web/css/base.css, per CLAUDE.md). Icons follow the app's icon language —
// the mobile keyboard row's `_svg` conventions (editor/
// mobile-keyboard-accessory.ts): 24×24 viewBox, stroke=currentColor,
// stroke-width 2.1, round caps/joins. Status colours come from the derived
// palette (p.success/p.warning/p.error…), never hardcoded hex.

// @ts-check

/**
 * @param {any} p - the derived bookmarklet palette.
 * @returns {string} the bookmarklet source string.
 */
export function buildExtractSrc(p: any) {
  return `(function(){
var STORAGE_KEY='pageExtractorFields';
var fields=[];
try{fields=JSON.parse(localStorage.getItem(STORAGE_KEY)||'[]');}catch(e){}
if(!fields.length){alert('No fields configured.\\nUse the Learn Page bookmarklet first.');return;}
if(!fields.some(function(f){return f.format==='url';}))fields.push({label:'Page URL',selector:'',attribute:'text',format:'url'});
var layout='row';
try{layout=localStorage.getItem('pageExtractorLayout')||'row';}catch(e){}
function getTableMd(el){
  var rows=Array.from(el.querySelectorAll('tr'));if(!rows.length)return '';
  var tbl=rows.map(function(row){
    var cells=Array.from(row.querySelectorAll('th,td')).map(function(c){return (c.innerText||c.textContent||'').trim().replace(/\\|/g,'\\\\|').replace(/\\n/g,' ');});
    return '| '+cells.join(' | ')+' |';
  });
  if(tbl.length>1){
    var headCells=Array.from(rows[0].querySelectorAll('th,td'));
    var probeCells=rows.length>1?Array.from(rows[1].querySelectorAll('th,td')):headCells;
    var sep=headCells.map(function(_,i){
      var c=probeCells[i]||headCells[i];
      var a=c&&c.getAttribute&&c.getAttribute('align');
      if(!a){try{a=(window.getComputedStyle(c).textAlign||'').toLowerCase();}catch(e){a='';}}
      if(a==='center')return ':---:';
      if(a==='right'||a==='end')return '---:';
      if(a==='left'||a==='start')return ':---';
      return '---';
    });
    tbl.splice(1,0,'| '+sep.join(' | ')+' |');
  }
  return tbl.join('\\n');
}
function getListMd(el,ordered){
  return Array.from(el.querySelectorAll(':scope > li')).map(function(li,idx){
    var t=(li.innerText||li.textContent||'').trim().split('\\n')[0].trim();
    return (ordered?(idx+1)+'. ':'- ')+t;
  }).join('\\n');
}
function getVal(sel,attr,fmt){
  if(!sel)return '';
  try{
    var el=document.querySelector(sel);if(!el)return '';
    if(fmt==='table')return getTableMd(el);
    if(fmt==='ul')return getListMd(el,false);
    if(fmt==='ol')return getListMd(el,true);
    if(attr==='href')return el.href||el.getAttribute('href')||'';
    if(attr==='src')return el.src||el.getAttribute('src')||'';
    if(attr==='datetime')return el.getAttribute('datetime')||el.innerText||'';
    if(attr==='content')return el.getAttribute('content')||'';
    return (el.innerText||el.textContent||'').trim().replace(/\\s+/g,' ');
  }catch(e){return '';}
}
function fmtMd(f,v){
  if(f.format==='blank')return '';
  if(f.format==='url')return '**'+(f.label||'URL')+':** '+window.location.href;
  if(!v)return '';
  switch(f.format){
    case 'h1':return '# '+v;
    case 'h2':return '## '+v;
    case 'h3':return '### '+v;
    case 'h4':return '#### '+v;
    case 'h5':return '##### '+v;
    case 'h6':return '###### '+v;
    case 'link':return '['+f.label+']('+v+')';
    case 'image':return '!['+f.label+']('+v+')';
    case 'italic':return '*'+v+'*';
    case 'quote':return '> '+v.split('\\n').join('\\n> ');
    case 'highlight':return '=='+v+'==';
    case 'ul':case 'ol':case 'table':return v;
    case 'plain':return v;
    default:return '**'+f.label+':** '+v;
  }
}
function fmtCell(f,v){
  if(f.format==='blank')return '';
  if(f.format==='url')return window.location.href;
  return String(v||'').replace(/[\\t\\n\\r]+/g,' ').trim();
}
var vals=fields.map(function(f){return getVal(f.selector,f.attribute,f.format);});
var missing=[];
fields.forEach(function(f,i){if(f.format!=='blank'&&f.format!=='url'&&!vals[i])missing.push(f.label);});
function buildOut(mode){
  if(mode==='row')return fields.map(function(f,i){return fmtCell(f,vals[i]);}).join('\\t');
  return fields.map(function(f,i){return fmtMd(f,vals[i]);}).filter(Boolean).join('\\n\\n');
}
var out=buildOut(layout);
function copyText(t,ok){if(navigator.clipboard&&navigator.clipboard.writeText){navigator.clipboard.writeText(t).then(ok).catch(function(){fbCopy(t);ok();});}else{fbCopy(t);ok();}}
function fbCopy(t){var ta=document.createElement('textarea');ta.value=t;ta.style.cssText='position:fixed;top:-9999px;left:-9999px;opacity:0;';document.body.appendChild(ta);ta.select();document.execCommand('copy');document.body.removeChild(ta);}
function escHtml(v){return String(v||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');}
function ic(d){return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'+d+'</svg>';}
var CHECK_IC=ic('<path d="m5 13 4 4 10-11"/>');
var WARN_IC=ic('<path d="M12 3 2 20h20L12 3z"/><path d="M12 9.5V14M12 17h.01"/>');
function showToast(ok){
  var ex=document.getElementById('pex-toast');if(ex)ex.remove();
  var toast=document.createElement('div');
  toast.id='pex-toast';
  toast.style.cssText='position:fixed;bottom:28px;right:28px;max-width:420px;min-width:260px;background:${p.bg};border-radius:14px;box-shadow:0 4px 16px rgba(0,0,0,0.28),0 8px 24px rgba(0,0,0,0.22);font-family:Arial,sans-serif;font-size:13px;z-index:2147483647;overflow:hidden;';
  var warnHtml=missing.length?'<div style="padding:6px 14px;background:${p.warningBg};font-size:11px;color:${p.warning};border-bottom:1px solid rgba(128,128,128,0.15);display:flex;align-items:center;gap:6px;">'+WARN_IC+'<span>Not Found: '+escHtml(missing.join(', '))+'</span></div>':'';
  var okLabel=layout==='row'?'Copied &#8212; Paste Into Excel':'Copied &#8212; Paste Into a Document';
  var altLabel=layout==='row'?'Copy as Document':'Copy as Excel Row';
  var preHtml=layout==='row'?escHtml(out).replace(/\\t/g,' <span style="color:${p.dim};">&#8594;</span> '):escHtml(out);
  toast.innerHTML=
    '<style>'+
    '#pex-toast,#pex-toast *{scrollbar-width:none!important;-ms-overflow-style:none!important;}'+
    '#pex-toast::-webkit-scrollbar,#pex-toast *::-webkit-scrollbar{display:none!important;width:0!important;height:0!important;}'+
    '#pex-toast svg{width:14px;height:14px;display:block;pointer-events:none;flex-shrink:0;}'+
    '</style>'+
    '<div style="background:'+(ok?'${p.successBg}':'${p.errorBg}')+';color:'+(ok?'${p.success}':'${p.error}')+';padding:9px 14px;font-weight:600;display:flex;align-items:center;gap:8px;">'+
    (ok?CHECK_IC:WARN_IC)+
    '<span>'+(ok?okLabel:'Copy Failed &#8212; Select Below')+'</span>'+
    '</div>'+
    warnHtml+
    '<pre style="margin:0;padding:10px 14px;font-size:10px;color:${p.code};max-height:180px;overflow-y:auto;white-space:pre-wrap;word-break:break-all;font-family:monospace;line-height:1.5;">'+preHtml+'</pre>'+
    '<div style="padding:7px 14px;display:flex;justify-content:space-between;align-items:center;">'+
    '<button id="pex-toast-alt" style="background:transparent;border:none;color:${p.accent};cursor:pointer;font-size:12px;font-family:Arial,sans-serif;">'+altLabel+'</button>'+
    '<button id="pex-toast-close" style="background:transparent;border:none;color:${p.muted};cursor:pointer;font-size:12px;font-family:Arial,sans-serif;">Dismiss</button>'+
    '</div>';
  document.body.appendChild(toast);
  document.getElementById('pex-toast-close').onclick=function(){toast.remove();};
  var hideT=setTimeout(function(){if(toast.parentNode){toast.style.transition='opacity 0.4s';toast.style.opacity='0';setTimeout(function(){if(toast.parentNode)toast.remove();},450);}},6000);
  document.getElementById('pex-toast-alt').onclick=function(){
    clearTimeout(hideT);
    var btn=this;
    copyText(buildOut(layout==='row'?'doc':'row'),function(){btn.textContent='\\u2713 Copied';setTimeout(function(){btn.textContent=altLabel;},1600);});
  };
}
copyText(out,function(){showToast(true);});
})();`;
}
